import React, { Component } from 'react'
import Activity from "framework/containers/Activity"

//redux
import { connect } from 'react-redux'
import { mapStateToProps, mapDispatchToProps } from 'framework/utils/Redux'

class ShopVariantActivity extends Component {

	constructor(props){
		super(props)
		this.RenderedComponent = import("app/components/Shop/Variant/VariantBrowser")
	}

	render() {
		return (
			<Activity 
				name="Variant"
				RenderedComponent={this.RenderedComponent}
				context="Variant"
			/>
		)
	}
}

export default connect(mapStateToProps,mapDispatchToProps)(ShopVariantActivity)
